export const DEFAULT_INPUT_SIZE = "small";
